import { propertyApi } from '../index'
import {
  preArrivalChecklistFormSubmission
} from '../../graphql_queries/form_management/preArrivalChecklistForm'

class PreArrivalChecklistForm {

  static submitForm (param) {
    return propertyApi.post('', {
      query: preArrivalChecklistFormSubmission(param)
    })
  }
}

export default PreArrivalChecklistForm
